import styled from "styled-components";

export const NameColumn = styled.div`
    flex-shrink: 0;
    flex-grow: 0;
    width: 100px;
`;

export const NameCell = styled(NameColumn)`
    font-size: 12px;
    text-transform: capitalize;
    padding-left: 0;
`;